import { setPersistedAtValue } from '../../../actions/quizAssessment/persistedAt'

export const quizPeristedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
}
